import React from 'react';

import { Container } from './DateSeparator.styled';
import { convertDateForm } from 'kb-shared/utilities/momentHelpers';
import { Message } from 'screens/Messages/Messages.type';

export const DateSeparator = ({
  previousMessage,
  currentMessage
}: {
  previousMessage?: Message;
  currentMessage: Message;
}) => {
  const previousMessageDate = previousMessage ? convertDateForm(previousMessage.createdAt) : null;
  const currentMessageDate = convertDateForm(currentMessage.createdAt);

  if (previousMessageDate === currentMessageDate) return null;

  const formattedDate = convertDateForm(currentMessage.createdAt, 'ddd DD, MMM YYYY');

  return <Container>{formattedDate}</Container>;
};
